import { z } from 'zod';

import { RegionSchema } from './region.model';

export type Donation = z.infer<typeof DonationSchema>;
export const DonationSchema = z.object({
  id: z.string().nonempty("Donation ID is required."),
  
  region: RegionSchema,
  videoUrl: z.string().url("Donation video url is invalid.").optional(),

  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});